import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://chip-plaid.webgarh.net/api',
});

// Add a request interceptor to attach the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors (like 401 Unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthPath = error.config?.url?.includes('/auth/');
    
    if (!isAuthPath && error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Handle unauthorized or forbidden access (e.g., clear localStorage and redirect to login)
      localStorage.clear();
      window.location.href = '/'; 
    }
    return Promise.reject(error);
  }
);

export default api;
